import { React, useEffect } from 'react';
import './gallery.css';
import logo from './img/edaplogo.png'
import pic1 from './img/class/1b.jpg';
import pic2 from './img/class/2c.jpg';
import pic3 from './img/class/3b.jpg';
import pic4 from './img/class/4.jpg';
import pic5 from './img/class/5.jpg';
import pic6 from './img/class/6.jpg';
import pic7 from './img/class/1c.jpg';
import pic8 from './img/class/2a.jpg';
import pic9 from './img/class/3a.jpg';
import pic10 from './img/class/break.jpg';
import Swipe from './swipe';
import Login from './login';
import Nav from './nav';

function Gallery() {
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      const logo = document.querySelector('.logo');

      if (window.scrollY > 10) {
        navbar.classList.add('scrolled');
        logo.classList.add('hide-logo');
      } else {
        navbar.classList.remove('scrolled');
        logo.classList.remove('hide-logo');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

    function scrollToTop(event) {
      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      });
      event.preventDefault();
      document.getElementById("scrollableDiv").scrollTo({
          top: 0,
          behavior: 'smooth'
      });
  }

  return (
    <div className="gbody">
        <Nav/>
        <body>
          <div className='gcontainer'>
            <div className='gslider' style={{margin: "40px auto"}}>
              <Swipe></Swipe>
            </div>
            <div className='gimages'>
              <img id='xmv' src={pic1}></img>
              <img src={pic2}></img>
              <img id='ymv' src={pic3}></img>
              <img src={pic4}></img>
              <img id='xmv' src={pic5}></img>
              <img id='xmv' src={pic6}></img>
              <img src={pic7}></img>
              <img id='ymv' src={pic8}></img>
              <img src={pic9}></img>
              <img id='xmv' src={pic10}></img>
            </div>
          </div>
      </body>
      <footer> EDAP-UNILIS © All Rights Reserved.</footer>
    </div>
  );
}

export default Gallery;

